//////////////////*Feature:Sortables/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function sortFunctions() {
    // first visit setup
    // assigns original positions in order to make reset work
    if (slides[globalVar.curSlide].visited === false) {
        var $sortables = globalVar.$curSlide.find('.sortable');
        $sortables.each(function (idx, sortable) {
            var id = sortable.id;

            // initialize sortables with or without options
            if (slides[globalVar.curSlide]['sort']['sortables'][id]) {
                if (slides[globalVar.curSlide]['sort']['sortables'][id]['options']) {
                    $(sortable).sortable(slides[globalVar.curSlide]['sort']['sortables'][id]['options']);
                } else {
                    $(sortable).sortable();
                }

                //makes beginning order default answer if no answer is given
                if (!slides[globalVar.curSlide]['sort']['sortables'][id]['answer']) {
                    slides[globalVar.curSlide]['sort']['sortables'][id]['answer'] = $(sortable).sortable('toArray');
                }
            } else {
                $(sortable).sortable();
            }

            var sortableElements = $('#' + id + '> div');
            // necessary to make a copy otherwise reassigning one of the data elements overwrites the other
            var shuffleElements = $('#' + id + '> div');

            // This handles keyboard accessibility for sortables

            sortableElements.each(function (idx, sort) {
                sortKeyboard(sort, sortable);
            });

            $(sortable).data({
                elements: sortableElements,
                shuffle: shuffleElements
            });
        });
    }

    // randomizes placement of divs every time the slide is entered
    if (slides[globalVar.curSlide]['sort']['randomize'] === true) {
        var $sortables2 = globalVar.$curSlide.find('.sortable');
        $sortables2.each(function (idx, sortable) {
            var elements = $(sortable).data('elements');
            var shuffleArr = [];

            // create an array of unique random numbers to serve as indices
            while (shuffleArr.length < elements.length) {
                var num = Math.floor(Math.random() * elements.length);
                // tests that the num variable has not already been added to the array
                if (
                    !shuffleArr.some(function (el) {
                        return el === num;
                    })
                ) {
                    shuffleArr.push(num);
                }
            }

            // use the array of random numbers to reassign elements in the shuffle data attribute
            for (var i = 0; i < elements.length; i++) {
                $(sortable).data('shuffle')[i] = $(sortable).data('elements')[shuffleArr[i]];
            }
        });
    }

    // randomizes across connected lists
    if (
        slides[globalVar.curSlide]['sort']['randomizeConnect'] &&
        typeof slides[globalVar.curSlide]['sort']['randomizeConnect'] === 'string'
    ) {
        var lists = $('.' + slides[globalVar.curSlide]['sort']['randomizeConnect']);
        var elementArr = [];
        var shuffled = [];
        lists.each(function (idx, list) {
            $(list)
                .find('div')
                .each(function (idx2, div) {
                    elementArr.push(div);
                });
        });

        while (elementArr.length) {
            var num = Math.floor(Math.random() * elementArr.length);
            element = elementArr.splice(num, 1);
            shuffled.push(element[0]);
        }

        var i = 0;
        while (shuffled.length) {
            lists.each(function (idx, list) {
                $(list).data('shuffle')[i] = shuffled.shift();
            });
            i++;
        }
    }

    resetSort();
}

// reset works for both randomized and non-randomized sort slides.  you do not need to put the randomize key if you don't need it.
// reset will either reset to the html order of divs or to the current randomized order
function resetSort() {
    var $sortables = globalVar.$curSlide.find('.sortable');
    $sortables.each(function (idx, sortable) {
        if (slides[globalVar.curSlide]['sort']['randomizeConnect']) {
            $(sortable).append($(sortable).data('shuffle'));
        } else if (
            slides[globalVar.curSlide]['sort']['randomize'] === false ||
            slides[globalVar.curSlide]['sort']['randomize'] === undefined
        ) {
            $(sortable).append($(sortable).data('elements'));
        } else {
            $(sortable).append($(sortable).data('shuffle'));
        }
    });
}

// accessibility function
function sortKeyboard(sortItem, sortList) {
    var connected = $(sortList).sortable('option', 'connectWith');

    $(sortItem)
        .attr('tabindex', 0)
        .on('keydown', function (event) {
            if (event.which === 87 || event.which === 65) {
                // left or up one space ('w', 'a')
                $(this).insertBefore($(this).prev());
            }
            if (event.which === 83 || event.which === 68) {
                // right or down one space ('s','d')
                $(this).insertAfter($(this).next());
            }
            if (event.which === 81) {
                // "q" top of list
                $(this)
                    .parent()
                    .prepend($(this));
            }
            if (event.which === 69) {
                // "e" bottom of list
                $(this)
                    .parent()
                    .append($(this));
            }
            if (connected && event.which === 88) {
                // 'x' move item to connected lists
                var newLists = [];
                var parentIndex;
                $(connected).each(function (idx, list) {
                    if (!$(list).find(event.target)[0]) {
                        newLists.push(list);
                    } else {
                        parentIndex = idx;
                    }
                });
                if (newLists[parentIndex]) {
                    $(newLists[parentIndex]).append($(this));
                } else {
                    $(newLists[0]).append($(this));
                }
            }
            $(this).focus();
        });
}